import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.array.every.js';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.array.is-array.js';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.array.some.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.string.includes.js';
import { __rest } from 'tslib';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { components } from 'react-select';
import classNames from 'classnames';
import uniqBy from 'lodash/uniqBy';
import { ClearAllIcon, CheckmarkIcon, InfoIcon, SelectIcon, ChevronUpIcon, ChevronDownIcon } from '@cognite/cogs-icons';
import { IconWrapper } from '@cognite/cogs-utils';
import { Checkbox } from '../checkbox/checkbox.js';
import { Divider } from '../divider/divider.js';
import { Tooltip } from '../tooltip/tooltip.js';

/**
 * Common components to override in React-Select
 */
var SELECT_ALL_VALUE = '<SELECT_ALL>';
var IndicatorSeparator = function IndicatorSeparator(_props) {
  return null;
};
var ClearIndicator = function ClearIndicator(props) {
  return components.CrossIcon && jsx(components.ClearIndicator, Object.assign({}, props, {
    className: "cogs-v10 " + props.className,
    children: jsx(ClearAllIcon, {})
  }));
};
var DropdownIndicator = function DropdownIndicator(props) {
  var menuIsOpen = props.selectProps.menuIsOpen;
  var getIcon = function getIcon(isOpen) {
    if (!Array.isArray(props.options) || props.options.length === 1) {
      return jsx(SelectIcon, {});
    }
    return isOpen ? jsx(ChevronUpIcon, {}) : jsx(ChevronDownIcon, {});
  };
  return components.DropdownIndicator && jsx(components.DropdownIndicator, Object.assign({}, props, {
    className: "cogs-v10 " + props.className,
    children: jsx(IconWrapper, {
      children: getIcon(menuIsOpen)
    })
  }));
};
var Control = function Control(props) {
  var _props$selectProps = props.selectProps,
    icon = _props$selectProps.icon,
    title = _props$selectProps.title;
  var prefix = (icon || title) && jsxs("span", {
    className: "cogs-v10 cogs-select--title",
    children: [icon && jsx(IconWrapper, {
      style: {
        marginRight: title && '8px'
      },
      children: icon
    }), title]
  });
  return components.Control && jsxs(components.Control, Object.assign({}, props, {
    className: "cogs-v10 " + props.className,
    children: [prefix, " ", props.children]
  }));
};
var MenuList = function MenuList(props) {
  var _props$selectProps2 = props.selectProps,
    menuHeader = _props$selectProps2.menuHeader,
    menuFooter = _props$selectProps2.menuFooter,
    dropdownRender = _props$selectProps2.dropdownRender;
  var HeaderFooter = function HeaderFooter(_ref) {
    var input = _ref.input,
      type = _ref.type;
    if (!input) return null;
    if (typeof input === 'string') {
      return jsx("p", {
        className: "cogs-v10 cogs-select__menu__text cogs-select__menu__text-" + type,
        children: input
      });
    }
    return jsx("div", {
      className: "cogs-v10 cogs-select__menu__button cogs-select__menu__button-" + type,
      children: input
    });
  };
  return components.MenuList && jsxs(Fragment, {
    children: [jsx(HeaderFooter, {
      input: menuHeader,
      type: "header"
    }), jsx(components.MenuList, Object.assign({}, props, {
      className: classNames('cogs-v10', props.className, menuHeader && 'cogs-select__menu--with-header', menuFooter && 'cogs-select__menu--with-footer'),
      options: props.options,
      children: dropdownRender ? dropdownRender(props.children) : props.children
    })), jsx(HeaderFooter, {
      input: menuFooter,
      type: "footer"
    })]
  });
};
var Option = function Option(props) {
  return jsxs(Fragment, {
    children: [jsxs(components.Option, Object.assign({}, props, {
      className: "cogs-v10 " + props.className,
      children: [jsxs("span", {
        children: [props.children, props.data.helpText && jsx(InfoTooltip, {
          helpText: props.data.helpText
        })]
      }), props.isSelected && jsx(CheckmarkIcon, {})]
    })), props.data.divider && jsx(Divider, {})]
  });
};
var CheckboxOptions = function CheckboxOptions(props) {
  var indeterminateState = function indeterminateState() {
    var isAllSelected = props.data.isAllSelected;
    if (!isAllSelected) return undefined;
    return !isAllSelected();
  };
  var handleIsAnySelected = function handleIsAnySelected() {
    var isAnySelected = props.data.isAnySelected;
    if (!isAnySelected) return false;
    return isAnySelected();
  };
  var isSelectAll = props.data.value === SELECT_ALL_VALUE;
  return jsxs(Fragment, {
    children: [jsx(components.Option, Object.assign({}, props, {
      className: "cogs-v10 " + props.className,
      children: jsxs(Checkbox, {
        checked: isSelectAll ? handleIsAnySelected() : props.isSelected,
        indeterminate: indeterminateState(),
        name: "checkbox-option",
        onChange: function onChange() {
          return null;
        },
        color: props.data.checkboxColor,
        children: [props.label, props.data.helpText && jsx(InfoTooltip, {
          helpText: props.data.helpText
        })]
      }, props.data.value)
    })), props.data.divider && jsx(Divider, {})]
  });
};
var GroupHeading = function GroupHeading(_a) {
  var isSelected = _a.isSelected,
    isIndeterminate = _a.isIndeterminate,
    props = __rest(_a, ["isSelected", "isIndeterminate"]);
  return jsx(components.GroupHeading, Object.assign({}, props, {
    className: "cogs-v10 " + props.className,
    children: jsx(components.Option, Object.assign({}, props, {
      className: "cogs-v10 " + props.className,
      children: jsx(Checkbox, {
        checked: isSelected,
        indeterminate: isIndeterminate,
        name: "checkbox-option",
        onChange: function onChange() {
          return null;
        },
        children: props.children
      }, props.children)
    }))
  }));
};
var Group = function Group(_a) {
  var children = _a.children,
    props = __rest(_a, ["children"]);
  var isAllSelected = props.options.every(function (option) {
    return option.isSelected;
  });
  var isAnySelected = props.options.some(function (option) {
    return option.isSelected;
  });
  var onClick = function onClick() {
    if (props.selectProps.onChange) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      var values = props.data.options.map(function (option) {
        return option.value;
      });
      props.selectProps.onChange(!isAllSelected ? uniqBy(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [].concat(props.selectProps.value, props.data.options), function (opt) {
        return opt.value;
      }) :
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      props.selectProps.value.filter(function (opt) {
        return !values.includes(opt.value);
      }).map(function (opt) {
        return Object.assign(Object.assign({}, opt), {
          options: opt.options ? opt.options.filter(function (innerOpt) {
            return !values.includes(innerOpt.value);
          }) : undefined
        });
      }), {
        action: 'select-option'
      });
    }
  };
  return jsx(components.Group, Object.assign({}, props, {
    className: "cogs-v10 " + props.className,
    Heading: GroupHeading,
    headingProps: Object.assign(Object.assign({}, props.headingProps), {
      onClick: onClick,
      isSelected: isAnySelected,
      isIndeterminate: isAnySelected && !isAllSelected
    }),
    children: jsx("div", {
      style: {
        paddingLeft: '24px'
      },
      children: children
    })
  }));
};
var InfoTooltip = function InfoTooltip(_ref2) {
  var helpText = _ref2.helpText;
  return jsx(Tooltip, {
    content: helpText,
    placement: "right",
    children: jsx(InfoIcon, {
      style: {
        marginLeft: '10px',
        verticalAlign: 'middle',
        color: 'rgba(0, 0, 0, 0.55)'
      }
    })
  });
};

export { CheckboxOptions, ClearIndicator, Control, DropdownIndicator, Group, IndicatorSeparator, MenuList, Option, SELECT_ALL_VALUE };
